import { getCurrentElement } from 'solid-element'

import { createEffect, createSignal, on, type ParentComponent } from 'solid-js'

type KyMobileDropDownToggleProps = {
  class?: string
}
export const KyMobileDropDownToggle: ParentComponent<KyMobileDropDownToggleProps> = (props) => {
  const currentElement = getCurrentElement()
  const [isOpen, setIsOpen] = createSignal(false)

  const container = currentElement?.children[0]

  const toggleButton = currentElement?.querySelector('[ky-mobile-drop-down-toggle="toggle"]')

  if (toggleButton) {
    toggleButton.addEventListener('click', () => {
      setIsOpen(!isOpen())
    })
  }
  createEffect(
    on(
      isOpen,
      (isOpen) => {
        if (isOpen) {
          container?.classList.add('is-open')
          container?.classList.add('z-50')
        } else {
          container?.classList.remove('is-open')
          container?.classList.remove('z-50')
        }
      },
      { defer: true }
    )
  )
  return <>{props.children}</>
}
